import gql from "graphql-tag";

export const CREATE_EVENT = gql`
  mutation AddEvent($data: EventDataInput) {
    addEvent(data: $data) {
      id
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation UpdateEvent($data: EventDataInput, $where: EventWhereInput) {
    updateEvent(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_EVENT = gql`
  mutation DeleteEvent($where: EventWhereInput) {
    deleteEvent(where: $where) {
      id
    }
  }
`;

const events = { CREATE_EVENT, UPDATE_EVENT, DELETE_EVENT };

export default events;
